import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  menu: {
    marginBottom: '30px',
    marginTop: '30px',
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'none',
    padding: '1rem',
    marginRight: '0.5rem',
    marginBottom: '1rem',
    borderRadius: '3px',
    backgroundColor: 'transparent',
    color: '#2096F3',
    border: '1px solid blue',

    '&:hover': {
      backgroundColor: '#2096F3',
      color: 'white',
      border: '1px solid #2096F3',
    },
  },

  linkHovered: {
    cursor: 'pointer',
    textDecoration: 'none',
    padding: '1rem',
    marginRight: '0.5rem',
    marginBottom: '1rem',
    borderRadius: '3px',
    backgroundColor: '#2096F3',
    color: 'white',
    border: '1px solid #2096F3',
  },
};

const DashboardMenu = ({ classes, active }) => {
  return (
    <div className={classes.menu}>
      <a className={active === 'cards' ? classes.linkHovered : classes.link} href="/#/dashboard">
        CARDS
      </a>

      <a className={active === 'reports' ? classes.linkHovered : classes.link} href="/#/dashboard/reports">
        REPORTS
      </a>

      <a className={active === 'graphs' ? classes.linkHovered : classes.link} href="/#/dashboard/graphs">
        GRAPHS
      </a>
    </div>
  );
};

export default withStyles(styles)(DashboardMenu);



// WEBPACK FOOTER //
// ./src/resources/dashboard/DashboardMenu.jsx